import { Box, type BoxProps } from '@chakra-ui/react';

interface CardProps extends BoxProps {
  /** Highlights the border, e.g. when the row is checked. */
  selected?: boolean;
  /** Lifts the border + shadow on hover. Off for static cards. */
  interactive?: boolean;
}

// The result-card shell every block renders its rows in.
export const Card = ({
  selected = false,
  interactive = true,
  children,
  ...rest
}: CardProps) => (
  <Box
    border="1px solid"
    borderColor={selected ? 'primary-300' : 'border-color'}
    borderRadius="10px"
    bg="base-white"
    px="14px"
    py="12px"
    transition="all 0.12s"
    _hover={
      interactive
        ? {
            borderColor: selected ? 'primary-300' : 'secondary-300',
            boxShadow: '0 1px 3px rgba(16,24,40,0.06)',
          }
        : undefined
    }
    {...rest}
  >
    {children}
  </Box>
);
